import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LinkIcon from '@material-ui/icons/Link';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomModal from '../modals/CustomModal';
import { prtStart, prtInput } from '../../utils/prt';

//****************************************************************************************** 
// This component renders a link with the text "Get Shareable Link". When a user clicks the 
// link, a custom modal pops up.  Inside the custom modal, it displays a title, and the 
// copy button along with some text.
// 
// Dependencies:
//    CustomModal - component acts as a wrapper providing the  modal behavior. The contents 
//          of the modal are passed via the children prop. 
//    React-Copy-To-Clipboard - component with button that copies text value you pass to it, 
//          to the clipboard.
//
// Inputs (to this component/parent): 
//     urlString - this is link you want to copy
//     
// Inputs (to CustomModal/child):  
//     showCustomModal prop - props used to open/close modal whose state is managed by this component.
//     children - whatever JSX we have between the <CustomModal> tags, gets passed in as the
//           children prop.    
//****************************************************************************************** 

const FNAME = "ShareableLink";
const TRACE = false;

//****************************************************************************************** 
// Styles - Defined one color because I need to pass it to Link activeStyle prop.
// I left container style and link style here because they did not work for some 
// reason inside the style sheet.
//****************************************************************************************** 

const blue = "#2980B7";

const containerStyle = {    /* leave this style here. Did not work when coded in stylesheet */
    display: 'flex',
    alignItems: 'center'
}

const copyButtonContainer = {    /* leave this style here. Did work when coded in stylesheet */
    display : 'flex',
    flexDirection: 'column',
    paddingLeft: '1rem',
    padding: '3% 5% 5%'
}

const linkStyle = {          /* leave this style here. Did not work when coded in stylesheet */
    color: blue,
    paddingLeft: '.5rem',
    textDecoration: 'none',
}


//************************************************************************************ 
// Component
//************************************************************************************ 

const ShareableLink = ({ urlString, linkName }) => {
    TRACE && prtStart(FNAME, "ShareableLink")

    TRACE && prtInput("urlString", urlString);
    TRACE && prtInput("linkName", linkName);

    // State used to manage opening and closing of CustomModal
    const [showCustomModal, setShowCustomModal] = useState(false);
    const [copied, setCopied] = useState(false);

    // Method used to open custom modal
    const handleOpenCustomModal   = () => { setShowCustomModal(true)  }
    const handleCloseCustomModal  = () => { setShowCustomModal(false) }
    const handleCancelCustomModal = () => { setShowCustomModal(false); setCopied(false) }    /* Used with cancel option or 'X out' option */

    return (
        <div style={containerStyle}>

            <LinkIcon className="slo-icon"/> 
            <div style={linkStyle} onClick={handleOpenCustomModal}>Get shareable link</div>

            <CustomModal showCustomModal={showCustomModal} >

                <div style={{display: 'flex', backgroundColor: blue, justifyContent: 'space-between', height: '4rem', width: '100%' }}> 
                    <p className="slc-modal-title"> Share Invitation  </p>
                    <p className="slc-modal-x-close-button"  onClick={handleCancelCustomModal}> X </p>
                </div>

                <div style={copyButtonContainer}>
            
                    <p className="slc-text">Copy link to clipboard and paste to your sending application (eg. text, email)</p>
                    <p className="slc-link-name">{linkName}</p>
                    <input className="slc-input" value={urlString}
                        onChange={(urlString) => { console.log(value) } }   
                    />
                    <CopyToClipboard text={urlString} onCopy={() => setCopied(true)}>
                        <button className="slc-copy-button">Copy to Clipboard</button>
                    </CopyToClipboard>
                    {copied ? <span className="slc-copied-msg"> Copied! <span style={{color: 'grey'}}> You may now paste to another application</span></span> : null }
                </div>

            </CustomModal> 

        </div>
    )
}

//************************************************************************************ 
// Prop Definitions
//************************************************************************************ 

ShareableLink.propTypes = {
    urlString:  PropTypes.string,     /* provide link as a url string */
    linkName:   PropTypes.string 
};


ShareableLink.defaultProps = {
    urlString:  "https://www.pitchinclub.com",
    linkName:   "The PitchInClub"
};

export default ShareableLink;



// WEBPACK FOOTER //
// ./src/components/links/ShareableLink.js